<img *ngIf="image"
  [src]="imageUrl"
  [title]="imageName"
  [alt]="imageName"
  decoding="async"
  [attr.loading]="loading">
<mat-spinner color="accent"
  *ngIf="isLoading&& showLoader"
  [diameter]="40"></mat-spinner>